import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Sidebar from './Sidebar';
import Header from './Header';
import { useLanguage } from '../../contexts/LanguageContext';

const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(true); // Default to open on desktop
  const [sidebarMobileOpen, setSidebarMobileOpen] = useState(false); // Separate state for mobile
  const { isRTL } = useLanguage();

  // Function to toggle sidebar
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  // Function to toggle mobile sidebar
  const toggleMobileSidebar = () => {
    setSidebarMobileOpen(!sidebarMobileOpen);
  };

  return (
    <div className={`min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 ${isRTL ? 'rtl' : 'ltr'}`}>
      <div className="flex h-screen overflow-hidden">
        {/* Desktop Sidebar */}
        <AnimatePresence mode="wait">
          <motion.div
            key="sidebar"
            initial={{ width: sidebarOpen ? 'auto' : 0 }}
            animate={{ width: sidebarOpen ? 'auto' : 0 }}
            exit={{ width: 0 }}
            transition={{ type: 'spring', stiffness: 300, damping: 30 }}
            className={`${isRTL ? 'order-2' : 'order-1'} relative z-30 hidden lg:block`}
          >
            <Sidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
          </motion.div>
        </AnimatePresence>

        {/* Main Content */}
        <div className={`flex-1 flex flex-col overflow-hidden ${isRTL ? 'order-1' : 'order-2'}`}>
          {/* Header */}
          <Header 
            sidebarOpen={sidebarOpen} 
            toggleSidebar={toggleSidebar}
            sidebarMobileOpen={sidebarMobileOpen}
            toggleMobileSidebar={toggleMobileSidebar} 
          />

          {/* Main Content Area */}
          <main className="flex-1 overflow-y-auto p-6">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="max-w-7xl mx-auto"
            >
              {children}
            </motion.div>
          </main>
        </div>
      </div>

      {/* Mobile Sidebar */}
      <AnimatePresence>
        {sidebarMobileOpen && (
          <>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={toggleMobileSidebar}
              className="fixed inset-0 bg-black/50 z-20 lg:hidden"
            />
            <motion.div
              initial={{ x: isRTL ? '100%' : '-100%' }}
              animate={{ x: 0 }}
              exit={{ x: isRTL ? '100%' : '-100%' }}
              transition={{ type: 'spring', stiffness: 300, damping: 30 }}
              className="fixed inset-y-0 left-0 z-30 w-64 lg:hidden"
            >
              <Sidebar sidebarOpen={true} toggleSidebar={toggleMobileSidebar} isMobile={true} />
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Layout; 